import * as React from 'react';
import { Link } from 'react-router-dom';

type BookingNavTileType = 'default' | 'struck';

interface IBookingNavTileProps extends React.PropsWithChildren {
	to?: string;
	type?: BookingNavTileType;
	onClick?: () => void;
}

export const BookingNavTile: React.FC<IBookingNavTileProps> = (props) => {
	const tileType = props.type || 'default';

	const classes = [
		'booking-nav-tile',
		`booking-nav-tile--${tileType}`
	];

	return <Link className={'booking-nav-tile__link'} to={props.to || '/'} onClick={props.onClick}>
		<div className={classes.join(' ')}>
			{props.children}
		</div>
	</Link>;
};
